import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getIsOnDemand, isOnEdgeChannel } from "~/store/selectors/selector.configOptions";

export const RequireSecurityFirewall = ({ children, redirectTo }) => {
  const isOnDemand = useSelector(getIsOnDemand);
  const isEdge = useSelector(isOnEdgeChannel);

  const accessGranted = useMemo(() => {
    return !isOnDemand || (isOnDemand && isEdge);
  }, [isEdge, isOnDemand]);

  return accessGranted ? children : <Navigate to={redirectTo} />;
};

RequireSecurityFirewall.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireSecurityFirewall.defaultProps = {
  redirectTo: "/not-found",
};
